import React, { useMemo } from 'react'
import { Cell, Row } from '../Elements'
import { IColumn } from './types'

type UseBody = {
  rows: Array<any>
  columns: Array<IColumn>
  lazy?: boolean
  itemsInPage: number
}

export const useBody = ({ lazy, columns, rows, itemsInPage }: UseBody) => {
  return useMemo(() => {
    const displayRows = lazy ? rows.slice(0, itemsInPage) : rows

    return displayRows.map((row, index) => {
      const id = row?.id || index
      const cells = columns.map((column, idx) => (
        <Cell
          key={`${id}_${column.field}${idx}${index}`}
          className={row?.['className'] || ''}
        >
          {row[column.field]}
        </Cell>
      ))

      return (
        <React.Fragment key={id + index}>
          <Row isOdd={index % 2 === 0}>{cells}</Row>
        </React.Fragment>
      )
    })
  }, [columns, rows, itemsInPage, lazy])
}
